// Handing in homework and reading the verdict on it — the block under a lesson.
// Shared words (statuses, "download", "remove") come from common.ts.

import { defineMessages, plural } from './index'

export default defineMessages(
  {
    title: 'Uy vazifasi',
    briefLabel: 'Vazifa sharti',
    requiredNote: 'Keyingi darsni ochish uchun uy vazifasini yuborish kerak.',
    acceptanceNote: 'Keyingi darsni ochish uchun uy vazifangiz qabul qilinishi kerak.',
    historyTitle: 'Yuborgan javoblaringiz',
    attemptN: '{n}-urinish',
    statusPending: 'Tekshirilmoqda',
    statusGraded: 'Qabul qilindi',
    statusRejected: 'Qaytarildi',
    gradeValue: 'Baho: {grade}',
    sentAt: 'Yuborilgan: {date}',
    reviewedAt: 'Tekshirilgan: {date}',
    reviewerComment: 'Tekshiruvchi izohi',
    rejectedHint: 'Izohni o‘qing, ishni tuzatib qayta yuboring.',
    waiting: 'Ishingiz tekshirilmoqda. Natija chiqqach, shu yerda ko‘rinadi.',
    answerLabel: 'Javobingiz',
    resendLabel: 'Qayta yuborish',
    answerPlaceholder: 'Nima qilganingizni yozing.',
    attachTitle: 'Fayllarni shu yerga tashlang yoki tanlash uchun bosing',
    attachHint:
      'Rasm (PNG, JPEG, GIF, WebP), PDF, TXT, audio (MP3, OGG, M4A), Word, Excel yoki PowerPoint — har biri 25 MB gacha.',
    filesLeft: 'Yana {n} ta fayl biriktirish mumkin.',
    filesFull: 'Fayl chegarasiga yetdingiz: ko‘pi bilan {max} ta.',
    tooMany: 'Bu vazifaga ko‘pi bilan {max} ta fayl biriktirish mumkin.',
    noFilesTaken: 'Bu vazifaga fayl biriktirilmaydi: javobni yuborish uchun fayllarni olib tashlang.',
    filesLimitChanged:
      'Bu vazifaga biriktiriladigan fayllar soni kamaytirildi. Yangi chegarani ko‘rish uchun sahifani yangilang.',
    fileGone: 'Bu fayl endi mavjud emas: olib tashlang va qayta biriktiring.',
    tooLarge: '«{name}» juda katta: har bir fayl 25 MB dan oshmasligi kerak.',
    uploaded: 'Yuklandi',
    uploadProgress: '«{name}» yuklanmoqda',
    removeFile: '«{name}» faylini olib tashlash',
    downloadFile: '«{name}» faylini yuklab olish',
    waitForUploads: 'Fayllar yuklanishini kuting.',
    dropFailed: 'Yuklanmagan fayllarni olib tashlang yoki qayta biriktiring.',
    needSomething: 'Javob yozing yoki fayl biriktiring.',
    submit: 'Vazifani yuborish',
    submitting: 'Yuborilmoqda…',
    sizeBytes: '{n} bayt',
    sizeKb: '{n} KB',
    sizeMb: '{n} MB',
    draftHint: 'Yozganingiz shu qurilmada saqlanib boradi va yuborguningizcha yo‘qolmaydi.',
    draftRestored: 'Yuborilmagan javobingiz tiklandi.',
    draftFilesDropped:
      'Bu vazifaga endi ko‘pi bilan {max} ta fayl biriktiriladi, shuning uchun saqlangan javobingizdagi ortiqcha fayllar olib tashlandi.',
    draftFilesDroppedAll:
      'Bu vazifaga endi fayl biriktirilmaydi, shuning uchun saqlangan javobingizdagi fayllar olib tashlandi.',
  },
  {
    en: {
      title: 'Homework',
      briefLabel: 'The task',
      requiredNote: 'You need to hand in this homework to open the next lesson.',
      acceptanceNote: 'Your homework has to be accepted before the next lesson opens.',
      historyTitle: 'Your submissions',
      attemptN: 'Attempt {n}',
      statusPending: 'Being reviewed',
      statusGraded: 'Accepted',
      statusRejected: 'Sent back',
      gradeValue: 'Grade: {grade}',
      sentAt: 'Sent: {date}',
      reviewedAt: 'Reviewed: {date}',
      reviewerComment: 'Reviewer’s comment',
      rejectedHint: 'Read the comment, fix your work and send it again.',
      waiting: 'Your work is being reviewed. The result will appear here.',
      answerLabel: 'Your answer',
      resendLabel: 'Send again',
      answerPlaceholder: 'Describe what you did.',
      attachTitle: 'Drop files here or click to choose',
      attachHint:
        'Images (PNG, JPEG, GIF, WebP), PDF, TXT, audio (MP3, OGG, M4A), Word, Excel or PowerPoint — up to 25 MB each.',
      filesLeft: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'You can attach {n} more file.',
          other: 'You can attach {n} more files.',
        }),
      filesFull: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'You have reached the limit of {n} file.',
          other: 'You have reached the limit of {n} files.',
        }),
      tooMany: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'This homework takes at most {n} file.',
          other: 'This homework takes at most {n} files.',
        }),
      noFilesTaken: 'This homework takes no files: remove them to send your answer.',
      filesLimitChanged: 'This homework now takes fewer files. Reload the page to see the new limit.',
      fileGone: 'This file is no longer available: remove it and attach it again.',
      tooLarge: '“{name}” is too large: each file can be at most 25 MB.',
      uploaded: 'Uploaded',
      uploadProgress: 'Uploading “{name}”',
      removeFile: 'Remove “{name}”',
      downloadFile: 'Download “{name}”',
      waitForUploads: 'Please wait for the files to finish uploading.',
      dropFailed: 'Remove the files that failed to upload, or attach them again.',
      needSomething: 'Write an answer or attach a file.',
      submit: 'Hand in homework',
      submitting: 'Sending…',
      sizeBytes: '{n} bytes',
      sizeKb: '{n} KB',
      sizeMb: '{n} MB',
      draftHint: 'What you write is kept on this device until you send it.',
      draftRestored: 'Your unsent answer has been restored.',
      draftFilesDropped: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'This homework now takes at most {n} file, so the extra files kept with your answer were left out.',
          other: 'This homework now takes at most {n} files, so the extra files kept with your answer were left out.',
        }),
      draftFilesDroppedAll: 'This homework no longer takes files, so the files kept with your answer were left out.',
    },
    ru: {
      title: 'Домашнее задание',
      briefLabel: 'Условие задания',
      requiredNote: 'Чтобы открыть следующий урок, нужно сдать домашнее задание.',
      acceptanceNote: 'Чтобы открыть следующий урок, домашнее задание должно быть принято.',
      historyTitle: 'Ваши ответы',
      attemptN: 'Попытка {n}',
      statusPending: 'На проверке',
      statusGraded: 'Принято',
      statusRejected: 'Возвращено',
      gradeValue: 'Оценка: {grade}',
      sentAt: 'Отправлено: {date}',
      reviewedAt: 'Проверено: {date}',
      reviewerComment: 'Комментарий проверяющего',
      rejectedHint: 'Прочитайте комментарий, исправьте работу и отправьте снова.',
      waiting: 'Ваша работа на проверке. Результат появится здесь.',
      answerLabel: 'Ваш ответ',
      resendLabel: 'Отправить снова',
      answerPlaceholder: 'Опишите, что вы сделали.',
      attachTitle: 'Перетащите файлы сюда или нажмите, чтобы выбрать',
      attachHint:
        'Изображения (PNG, JPEG, GIF, WebP), PDF, TXT, аудио (MP3, OGG, M4A), Word, Excel или PowerPoint — до 25 МБ каждый.',
      filesLeft: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Можно приложить ещё {n} файл.',
          few: 'Можно приложить ещё {n} файла.',
          many: 'Можно приложить ещё {n} файлов.',
          other: 'Можно приложить ещё {n} файла.',
        }),
      filesFull: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'Достигнут предел: не больше {n} файла.',
          few: 'Достигнут предел: не больше {n} файлов.',
          many: 'Достигнут предел: не больше {n} файлов.',
          other: 'Достигнут предел: не больше {n} файлов.',
        }),
      tooMany: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'К этому заданию можно приложить не больше {n} файла.',
          few: 'К этому заданию можно приложить не больше {n} файлов.',
          many: 'К этому заданию можно приложить не больше {n} файлов.',
          other: 'К этому заданию можно приложить не больше {n} файлов.',
        }),
      noFilesTaken: 'К этому заданию нельзя прикладывать файлы: уберите их, чтобы отправить ответ.',
      filesLimitChanged:
        'К этому заданию теперь можно приложить меньше файлов. Обновите страницу, чтобы увидеть новый предел.',
      fileGone: 'Этот файл больше недоступен: уберите его и приложите заново.',
      tooLarge: '«{name}» слишком большой: каждый файл — не больше 25 МБ.',
      uploaded: 'Загружено',
      uploadProgress: 'Загружается «{name}»',
      removeFile: 'Убрать «{name}»',
      downloadFile: 'Скачать «{name}»',
      waitForUploads: 'Дождитесь окончания загрузки файлов.',
      dropFailed: 'Уберите файлы, которые не загрузились, или приложите их снова.',
      needSomething: 'Напишите ответ или приложите файл.',
      submit: 'Сдать задание',
      submitting: 'Отправляем…',
      sizeBytes: '{n} Б',
      sizeKb: '{n} КБ',
      sizeMb: '{n} МБ',
      draftHint: 'Написанное сохраняется на этом устройстве, пока вы его не отправите.',
      draftRestored: 'Ваш неотправленный ответ восстановлен.',
      draftFilesDropped: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'К этому заданию теперь можно приложить не больше {n} файла, поэтому лишние файлы из сохранённого ответа убраны.',
          few: 'К этому заданию теперь можно приложить не больше {n} файлов, поэтому лишние файлы из сохранённого ответа убраны.',
          many: 'К этому заданию теперь можно приложить не больше {n} файлов, поэтому лишние файлы из сохранённого ответа убраны.',
          other:
            'К этому заданию теперь можно приложить не больше {n} файлов, поэтому лишние файлы из сохранённого ответа убраны.',
        }),
      draftFilesDroppedAll:
        'К этому заданию больше нельзя прикладывать файлы, поэтому файлы из сохранённого ответа убраны.',
    },
    de: {
      title: 'Hausaufgabe',
      briefLabel: 'Aufgabenstellung',
      requiredNote: 'Um die nächste Lektion zu öffnen, müssen Sie diese Hausaufgabe abgeben.',
      acceptanceNote: 'Ihre Hausaufgabe muss angenommen werden, bevor die nächste Lektion öffnet.',
      historyTitle: 'Ihre Abgaben',
      attemptN: 'Versuch {n}',
      statusPending: 'Wird geprüft',
      statusGraded: 'Angenommen',
      statusRejected: 'Zurückgegeben',
      gradeValue: 'Note: {grade}',
      sentAt: 'Gesendet: {date}',
      reviewedAt: 'Geprüft: {date}',
      reviewerComment: 'Kommentar der prüfenden Person',
      rejectedHint: 'Lesen Sie den Kommentar, verbessern Sie Ihre Arbeit und senden Sie sie erneut.',
      waiting: 'Ihre Arbeit wird geprüft. Das Ergebnis erscheint hier.',
      answerLabel: 'Ihre Antwort',
      resendLabel: 'Erneut senden',
      answerPlaceholder: 'Beschreiben Sie, was Sie gemacht haben.',
      attachTitle: 'Dateien hierher ziehen oder zum Auswählen klicken',
      attachHint:
        'Bilder (PNG, JPEG, GIF, WebP), PDF, TXT, Audio (MP3, OGG, M4A), Word, Excel oder PowerPoint – jeweils bis 25 MB.',
      filesLeft: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Sie können noch {n} Datei anhängen.',
          other: 'Sie können noch {n} Dateien anhängen.',
        }),
      filesFull: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'Das Limit von {n} Datei ist erreicht.',
          other: 'Das Limit von {n} Dateien ist erreicht.',
        }),
      tooMany: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'Diese Hausaufgabe nimmt höchstens {n} Datei an.',
          other: 'Diese Hausaufgabe nimmt höchstens {n} Dateien an.',
        }),
      noFilesTaken: 'Diese Hausaufgabe nimmt keine Dateien an: Entfernen Sie sie, um Ihre Antwort zu senden.',
      filesLimitChanged:
        'Diese Hausaufgabe nimmt jetzt weniger Dateien an. Laden Sie die Seite neu, um das neue Limit zu sehen.',
      fileGone: 'Diese Datei ist nicht mehr verfügbar: Entfernen Sie sie und hängen Sie sie erneut an.',
      tooLarge: '„{name}“ ist zu groß: jede Datei darf höchstens 25 MB haben.',
      uploaded: 'Hochgeladen',
      uploadProgress: '„{name}“ wird hochgeladen',
      removeFile: '„{name}“ entfernen',
      downloadFile: '„{name}“ herunterladen',
      waitForUploads: 'Bitte warten Sie, bis die Dateien hochgeladen sind.',
      dropFailed: 'Entfernen Sie die nicht hochgeladenen Dateien oder hängen Sie sie erneut an.',
      needSomething: 'Schreiben Sie eine Antwort oder hängen Sie eine Datei an.',
      submit: 'Hausaufgabe abgeben',
      submitting: 'Wird gesendet…',
      sizeBytes: '{n} Byte',
      sizeKb: '{n} KB',
      sizeMb: '{n} MB',
      draftHint: 'Was Sie schreiben, bleibt auf diesem Gerät gespeichert, bis Sie es senden.',
      draftRestored: 'Ihre noch nicht gesendete Antwort wurde wiederhergestellt.',
      draftFilesDropped: (v, lang) =>
        plural(lang, Number(v.max), {
          one: 'Diese Hausaufgabe nimmt jetzt höchstens {n} Datei an, daher wurden die überzähligen Dateien Ihrer gespeicherten Antwort entfernt.',
          other:
            'Diese Hausaufgabe nimmt jetzt höchstens {n} Dateien an, daher wurden die überzähligen Dateien Ihrer gespeicherten Antwort entfernt.',
        }),
      draftFilesDroppedAll:
        'Diese Hausaufgabe nimmt keine Dateien mehr an, daher wurden die Dateien Ihrer gespeicherten Antwort entfernt.',
    },
  },
)
